import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigurationSettings } from '../models/client-settings';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  public configurationSettings$ = new BehaviorSubject<ConfigurationSettings>(null);

  public updateConfigurationSettings(configurationSettings: ConfigurationSettings): void {
    this.configurationSettings$.next(configurationSettings);
  }
}
